import { heroStats } from "@/pages/home/data";

export default function Hero() {
  return (
    <section id="top" className="relative w-full isolate overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20layered%20paper%20folds%20and%20soft%20geometric%20blocks%20in%20warm%20terracotta%20brick%20amber%20and%20cream%20tones%2C%20archival%20dossier%20texture%2C%20dramatic%20low%20side%20lighting%20with%20deep%20soft%20shadows%2C%20minimal%20editorial%20composition%2C%20muted%20earthy%20palette%2C%20fine%20grain%2C%20wide%20negative%20space%20suitable%20as%20a%20website%20hero%20background%20for%20text%20overlay&width=1600&height=1000&seq=hl-hero-2026a&orientation=landscape"
          alt="黑料投稿审核中心主题视觉：层叠档案质感与暖色几何构成"
          title="黑料投稿审核标准与发布规则 · 主题视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/55 via-foreground-950/45 to-foreground-950/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="max-w-4xl mx-auto text-center">
          <span className="animate-rise inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs md:text-sm text-accent-200 bg-foreground-950/30 ring-1 ring-accent-300/40 backdrop-blur-sm">
            <i className="ri-information-line" aria-hidden="true"></i>
            审核标准 · 发布规则 · 处理时长 · 曝光流程
          </span>

          <h1 className="animate-rise mt-6 font-heading font-bold text-background-50 leading-[1.15] tracking-tight">
            <span className="block text-3xl md:text-5xl lg:text-6xl">
              黑料投稿审核中心
            </span>
            <span className="mt-3 md:mt-4 block text-lg md:text-2xl font-medium text-accent-200">
              审核标准 · 发布规则 · 曝光流程
            </span>
          </h1>

          <p className="animate-rise mt-6 md:mt-8 mx-auto max-w-2xl text-sm md:text-lg leading-relaxed text-background-100">
            从<strong className="font-semibold text-background-50">黑料投稿</strong>提交到内容曝光，每一步流程透明可查。这里公开
            <strong className="font-semibold text-background-50">审核标准</strong>、
            <strong className="font-semibold text-background-50">发布规则</strong>、处理时长与删除原因，帮助你在投稿前做好准备，避免因流程不清而延误曝光。
          </p>

          <div className="animate-rise mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#standards"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看审核标准
            </a>
            <a
              href="#process"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 text-background-50 text-sm md:text-base font-medium ring-1 ring-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              了解曝光流程
            </a>
          </div>

          <dl className="animate-rise-slow mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px overflow-hidden rounded-lg bg-background-50/15 ring-1 ring-background-50/20 backdrop-blur-sm">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="bg-foreground-950/25 px-4 py-5 md:py-6 text-center"
              >
                <dt className="sr-only">{stat.label}</dt>
                <dd className="font-heading text-xl md:text-3xl font-bold text-accent-300">
                  {stat.value}
                </dd>
                <p className="mt-1.5 text-xs md:text-sm text-background-100">
                  {stat.label}
                </p>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}